import React, { useState } from 'react'
import Group from './Group'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faCar , faSearch } from '@fortawesome/free-solid-svg-icons'
import Creategroup from './Creategroup'
import { useSelector } from 'react-redux'

// const element = <FontAwesomeIcon icon={faPlus} />




function Grouplist() {

    const groups = useSelector(state => state.rooms)
    const [filter , setFilter] = useState('');
    let filtered_groups = groups;
    if(filter){
        filtered_groups = groups.filter( group=>{
            if( group.name.indexOf(filter) > -1)
                return true;
            return false;
        })
    }
    return (
        <div className = "left-chatbox-container">
            <div className = "group-list-header">
                <h1>Groups</h1>
            </div>
            <div className = "group-search-container">
            <FontAwesomeIcon icon={faSearch} />
            <input
            className = "group-filter-input"
            value = {filter}
            onChange = {(e)=> setFilter(e.target.value)}
            placeholder = "Search Groups.."></input>
            </div>


            <div className = "list-group-container">{
                filtered_groups.map((group,index) => <Group icon = {<FontAwesomeIcon icon={faCar}/>} key = {index} group={group}></Group>)
            }
            </div>
            <Creategroup></Creategroup>
        </div>
    )
}

export default Grouplist